import { create } from 'zustand';

interface EditingElement {
  section: string;
  key: string;
  type: 'text' | 'image';
  currentValue: string;
}

interface AdminOverlayState {
  isOverlayEnabled: boolean;
  editingElement: EditingElement | null;

  // Actions
  toggleOverlay: () => void;
  enableOverlay: () => void;
  disableOverlay: () => void;
  setEditingElement: (element: EditingElement | null) => void;
  closeEditor: () => void;
}

export const useAdminOverlayStore = create<AdminOverlayState>((set) => ({
  isOverlayEnabled: false,
  editingElement: null,

  toggleOverlay: () => set((state) => ({
    isOverlayEnabled: !state.isOverlayEnabled,
    // Close any open editor when disabling overlay
    editingElement: state.isOverlayEnabled ? null : state.editingElement
  })),

  enableOverlay: () => set({ isOverlayEnabled: true }),

  disableOverlay: () => set({
    isOverlayEnabled: false,
    editingElement: null
  }),

  setEditingElement: (element) => set({ editingElement: element }),

  closeEditor: () => set({ editingElement: null }),
}));
